import { CurrentInfoService } from '../../current-info/current-info.service';
import { DashboardViewService } from './dashboard-view.service';
import { DeviceUpdateAction, IDashboardChangeConfirmationData } from '../models/models';
import { Injectable } from '@angular/core';
import { ScheduleService } from '../../schedule/schedule.service';
import { SystemSettingsService } from '../../system-settings/system-settings.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardUpdateActions {

    selector = {
        [DeviceUpdateAction.CONTROL_SUMMARY]: (data: IDashboardChangeConfirmationData) =>
            this.dashboardViewService.updateControlSummary(data.deviceInfo, data.hardwareItemId),
        [DeviceUpdateAction.CURRENT_INFORMATION]: (data: IDashboardChangeConfirmationData) =>
            this.currentInfoService.updateCurrentInformation(data.deviceInfo, data.hardwareItemId),
        [DeviceUpdateAction.DEVICE_INFORMATION]: (data: IDashboardChangeConfirmationData) =>
            this.systemSettingsService.updateDeviceInformation(data.deviceInfo, data.hardwareItemId),
        [DeviceUpdateAction.SCHEDULE]: (data: IDashboardChangeConfirmationData) =>
            this.scheduleService.updateScheduling(data.deviceInfo),
    }

    constructor(
        private currentInfoService: CurrentInfoService,
        private dashboardViewService: DashboardViewService,
        private scheduleService: ScheduleService,
        private systemSettingsService: SystemSettingsService,
    ) {
    }

    update(data: IDashboardChangeConfirmationData) {
        return this.selector[data.action](data);
    }
}
